<template>
  <div>
    <TsTypography
      weight="semibold"
      appendClass="text-natural-grey mb-4 text-base"
    >
    {{useTranslation("fillOneField" , "Vul minimaal één veld in, zodat wij uw bedrijf kunnen identificeren.")}}

    </TsTypography>
    <div class="pb-28 max-w-[460px]">
      <TsInput
        :data-testid="baseDataTestId + 'commerce-number-input'"
        v-model="procardStore.application_form.commerce_number_search_item"
        @input="procardStore.errors.company_details = ''"
        @keydown.enter.exact.prevent="emit('next')"
        appendClass="mb-4"
        :placeholder="useTranslation('chamberOfCommerceNumber' , 'Kamer van Koophandel nummer')"

      />

      <TsInput
        :data-testid="baseDataTestId + 'company-name-input'"
        :placeholder="useTranslation('companyName' , 'Bedrijfsnaam')"
        @input="onInputCompanyName()"
        @keydown.enter.exact.prevent="emit('next')"
        v-model="procardStore.application_form.company_name_search_item"
      />

      <TsTypography
        v-if="procardStore.errors.company_details"
        weight="semibold"
        variant="sm"
        append-class="text-danger mt-2"
        data-testid="pro-card-company-details-error"
        >{{ procardStore.errors.company_details }}</TsTypography
      >
    </div>
    <TsProCardFormBottomBar
      @back="emit('back')"
      @next="emit('next')"
      @draft="emit('draft')"
      :next-button="{
        disabled: !enableNextStep,
        isLoading: procardStore.loading.company_list,
      }"
      :save-button="{
        disabled: !enableSaveAsDraft,
        isLoading: procardStore.loading.save_button,
      }"
    />
  </div>
</template>

<script setup lang="ts">
const procardStore = useProCardStoreV2();
const baseDataTestId = "pro-card-application-company-details-";

const enableNextStep = computed(() =>
  Boolean(
    (procardStore.application_form.commerce_number_search_item ||
      procardStore.application_form.company_name_search_item) &&
      !procardStore.errors.company_details
  )
);

const enableSaveAsDraft = computed(() =>
  Boolean(
    procardStore.application_form.commerce_number_search_item ||
      procardStore.application_form.company_name_search_item
  )
);

function onInputCompanyName() {
  procardStore.application_form.company_duns = ''
  procardStore.application_form.company_name = "";
  procardStore.application_form.company_address_city = "";
  procardStore.application_form.company_address_line1 = "";
  procardStore.application_form.company_country = "";
  procardStore.application_form.company_postcode = "";
  procardStore.application_form.company_incorporated_date = "";
  procardStore.application_form.company_vat = "";
  procardStore.application_form.company_registration_number = "";
  procardStore.application_form.account_holder_name = "";
  procardStore.application_form.bank_details= {
    account_holder_name: "",
        iban: "",
        type: "Company",
        bank: {
      Name: "",
          Bic: "",
    },
  };
  procardStore.errors.company_details = ''
}

const TsProCardFormBottomBar = defineAsyncComponent(
    () => import('~/components/procard/TsProCardFormBottomBar.vue')
);

const emit = defineEmits<{
  back: any;
  next: any;
  draft: any;
}>();
</script>
